import React from "react";
import PropTypes from "prop-types";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
/*istanbul ignore next */
export const contentItemShape = PropTypes.shape({
  contentId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  name: PropTypes.string,
  contents: PropTypes.arrayOf(PropTypes.any),
  contentAssociationStatus: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.bool,
  ]),
  activitystatus: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  documentType: PropTypes.number,
});
/*istanbul ignore next */
export const LevelThreeItem = ({ data, myRef }) => (
  <div className="accordion-class-1 accordion-class-5" ref={myRef}>
    <Typography sx={{ fontWeight: "700" }}>{data.name}</Typography>
  </div>
);

LevelThreeItem.propTypes = {
  data: contentItemShape.isRequired,
  myRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
};
/*istanbul ignore next */
export const LevelTwoAccordion = ({
  parentId,
  data,
  isExpanded,
  handleChangeExpanded,
  myRef,
}) => {
  if (!data.contents || data.contents.length === 0) {
    return (
      <div className="accordion-class-1 accordion-class-7" ref={myRef}>
        <Typography sx={{ fontWeight: "700" }}>{data.name}</Typography>
      </div>
    );
  }

  return (
    <Accordion
      className="accordion-class-2"
      expanded={isExpanded(`accordion-header-${parentId}-${data.contentId}`)}
      onChange={() =>
        handleChangeExpanded(`accordion-header-${parentId}-${data.contentId}`)
      }
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon style={{ color: "black" }} />}
        aria-controls="panel1a-content"
        className="accordion-class-4 accordion-class-7"
      >
        <Typography sx={{ fontWeight: "700" }}>{data.name}</Typography>
      </AccordionSummary>
      <AccordionDetails className="accordion-class-3">
        <div>
          {data.contents.map((z) => (
            <LevelThreeItem
              key={`accordion-${parentId}-${data.contentId}-${z.contentId}`}
              data={z}
              myRef={myRef}
            />
          ))}
        </div>
      </AccordionDetails>
    </Accordion>
  );
};

LevelTwoAccordion.propTypes = {
  parentId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    .isRequired,
  data: contentItemShape.isRequired,
  isExpanded: PropTypes.func.isRequired,
  handleChangeExpanded: PropTypes.func.isRequired,
  myRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
};
/*istanbul ignore next */
export const LevelOneAccordion = ({
  data,
  isExpanded,
  handleChangeExpanded,
  loadTextHeading,
  myRef,
}) => {
  if (!data.contents || data.contents.length === 0) {
    return <div>{loadTextHeading(data, false)}</div>;
  }

  return (
    <Accordion
      className="accordion-class-2"
      expanded={isExpanded(`accordion-header-${data.contentId}`)}
      onChange={() =>
        handleChangeExpanded(`accordion-header-${data.contentId}`)
      }
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon style={{ color: "black" }} />}
        aria-controls="panel1a-content"
        className="accordion-class-4"
      >
        {loadTextHeading(data, true)}
      </AccordionSummary>
      <AccordionDetails className="accordion-class-3">
        <div>
          {data.contents.map((y) => (
            <LevelTwoAccordion
              key={`accordion-${data.contentId}-${y.contentId}`}
              parentId={data.contentId}
              data={y}
              isExpanded={isExpanded}
              handleChangeExpanded={handleChangeExpanded}
              myRef={myRef}
            />
          ))}
        </div>
      </AccordionDetails>
    </Accordion>
  );
};

LevelOneAccordion.propTypes = {
  data: contentItemShape.isRequired,
  isExpanded: PropTypes.func.isRequired,
  handleChangeExpanded: PropTypes.func.isRequired,
  loadTextHeading: PropTypes.func.isRequired,
  myRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
};
